<template>
    <div>
        <el-col>
            <el-menu
                v-if="getMenu && getMenu.length"
                :unique-opened='true'
                :router="true"
                class="el-menu-vertical-demo"
                background-color="transparent"
                text-color="#444"
                :default-active="logUrl"
                :collapse="isCollapse"
                :collapse-transition = "false"
            >
                <common-menu :getMenu="getMenu" :isCollapse="isCollapse"></common-menu>
            </el-menu>
        </el-col>
    </div>
</template>
<script>
import CommonMenu from './menu'
import { mapState,mapActions } from "vuex";
export default {
    name:'sidelist',
    props:{
        isCollapse:Boolean,
    },
    data(){
        return{
            getMenu:[],
        }
    },
    components: {
        CommonMenu
    },
    computed:{
        logUrl(){
            return this.$store.state.logUrl;
        }
    },
    methods:{
        ...mapActions([  
            'saveMenu',"saveLogUrl"
        ]),
        // 存储点击的菜单
        // getIndex(index,val){
        //     this.saveLogUrl({logUrl:index});
        // },
        //获取菜单
        findTreeDatas:function(){
            this.$api.post(this.API.api + 'home/onLoadSysMenu',{},res=>{
                this.getMenu = res.data; 
                this.saveMenu(this.getMenu);
            })
        },
    },
    created(){
        this.saveMenu(this.getMenu);
        this.findTreeDatas();
    },
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 220px;
    min-height: 400px;
  }
</style>




// WEBPACK FOOTER //
// src/views/components/SideList.vue